export default __webpack_public_path__ + "static/media/checklist-1.7dc03f4f.png";